import { NormalizedFuelDetail, TransportationProvider } from './generated/api';

const mail = 'irisscout@porsche.co.at';
export default mail;

export const imprintMail = 'alluc@porsche.co.at'; // yes, the imprint mail is different

export const MAX_NUMBER_CHECKABLE = 3;

export const LANGUAGES_WITH_INSTRUCTIONS = ['de', 'en', 'fr'];

// BE routes that proxy to UCP -- these authenticate the BE upstream, not the caller's session.
export const UCP_PROXY_PATH_PREFIX = '/api/proxy/ucp/';

export const kvpsLocalStorageKey = 'gwscout/PREFERRED_KVPS';
export const transportOptionLocalStorage = 'gwscout/PREFERRED_TRANSPORT_OPTION';
export const authenticationStorageKey = 'gwscout/accessToken';
// sessionStorage, not localStorage: one SSO attempt per browser session, not per browser install.
export const authRedirectAttemptKey = 'gwscout/authRedirectAttempted';
// Cleared on sign-in by the "reset valuation on every login" rule. Stale: valuation moved out of
// the CarsTable store and now lives under `gwscout/valuation{Country,Type}`
// (see hooks/useValuationSettings.ts), so nothing reads these and the reset is a no-op. Kept
// pointing at the old keys deliberately -- switching them over would start resetting valuation on
// every login, which is a product decision and not part of this refactor.
export const legacyValuationCountryStorageKey = 'gwscout/CarsTable.valuationCountry';
export const legacyValuationTypeStorageKey = 'gwscout/CarsTable.valuationType';
export const bidVisibilityLocalStorageKey = 'gwscout/bidVisibility';
export const notificationLocalStorageKey = 'gwscout/notifications';

export const DELIVERY_ADDRESS_VALIDATION = {
  companyName: { maxLength: 40 },
  name: { maxLength: 30 },
  email: { maxLength: 120 },
  phoneNumber: { maxLength: 16 },
  street: { maxLength: 71 },
  zip: { maxLength: 10 },
  city: { maxLength: 40 },
  contactPersonName: { maxLength: 120 },
  betriebsId: { maxLength: 16 },
  addressCode: { maxLength: 16 },
};

export const ORIGIN_SOURCE_GROUP_ITEMS = [
  { value: 'VTI', label: 'carsTableNext.filter.originSources.VTI', group: 'allVTI' },
  { value: 'WA-RUECK', label: 'carsTableNext.filter.originSources.WA_RUECK', group: 'allVWAG' },
  { value: 'WANDLUNG', label: 'carsTableNext.filter.originSources.WANDLUNG', group: 'allVWAG' },
  { value: 'RUECK', label: 'carsTableNext.filter.originSources.RUECK', group: 'allVWAG' },
  { value: 'WA-LEASING', label: 'carsTableNext.filter.originSources.WA-LEASING', group: 'allVWAG' },
  { value: 'NW KZL VW', label: 'carsTableNext.filter.originSources.NW_KZL_VW', group: 'allVWAG' },
  { value: 'MIETFZG FS', label: 'carsTableNext.filter.originSources.MIETFZG_FS', group: 'allVWAG' },
  { value: 'MIETFZG VW', label: 'carsTableNext.filter.originSources.MIETFZG_VW', group: 'allVWAG' },
  { value: 'GFZ VW FS', label: 'carsTableNext.filter.originSources.GFZ_VW_FS', group: 'allVWAG' },
  { value: 'GFZ VW', label: 'carsTableNext.filter.originSources.GFZ_VW', group: 'allVWAG' },
  { value: 'VGSG RAC', label: 'carsTableNext.filter.originSources.VGSG_RAC', group: 'allVWAG' },
  { value: 'SAD', label: 'carsTableNext.filter.originSources.SAD', group: 'allSkoda' },
  { value: 'SAD WANDL', label: 'carsTableNext.filter.originSources.SAD_WANDL', group: 'allSkoda' },
  { value: 'SEAT', label: 'carsTableNext.filter.originSources.SEAT', group: 'allSeat' },
  { value: 'SEAT WANDL', label: 'carsTableNext.filter.originSources.SEAT_WANDL', group: 'allSeat' },
  { value: 'ITAVWLRAC', label: 'carsTableNext.filter.originSources.ITAVWLRAC', group: 'allVWFSItaly' },
  { value: 'VWFSItaly', label: 'carsTableNext.filter.originSources.VWFSItaly', group: 'allVWFSItaly' },
  {
    value: 'SVK Standard Lease Return',
    label: 'carsTableNext.filter.originSources.SVK_STANDARD_LEASE_RETURN',
    group: 'allSlowakei',
  },
  { value: 'SVK Insolvencies', label: 'carsTableNext.filter.originSources.SVK_INSOLVENCIES', group: 'allSlowakei' },
  { value: 'EMG', label: 'carsTableNext.filter.originSources.EMG', group: 'allEMG' },
  { value: 'DNK OLeas', label: 'carsTableNext.filter.originSources.DNK_OLEAS', group: 'allDNK' },
  { value: 'DNK FLeas', label: 'carsTableNext.filter.originSources.DNK_FLEAS', group: 'allDNK' },
  { value: 'DNK Lux', label: 'carsTableNext.filter.originSources.DNK_LUX', group: 'allDNK' },
  { value: 'FRA Employee leasing', label: 'carsTableNext.filter.originSources.FRA_EMPLOYEE_LEASING', group: 'allFRA' },
  { value: 'FRA RAC', label: 'carsTableNext.filter.originSources.FRA_RAC', group: 'allFRA' },
  { value: 'FRA all', label: 'carsTableNext.filter.originSources.FR_ALL', group: 'allFRA' },
  { value: 'PRT Op. Leasing', label: 'carsTableNext.filter.originSources.PRT_OP_LEASING', group: 'allPRT' },
  { value: 'PRT Fin. Leasing', label: 'carsTableNext.filter.originSources.PRT_FIN_LEASING', group: 'allPRT' },
  { value: 'PRT Auto Credit', label: 'PRT Auto Credit', group: 'allPRT' },
];

// Transportation Variables
export const PROVIDERS_WITH_FEE: TransportationProvider[] = [
  TransportationProvider.VwfsAllmobilTransport,
  TransportationProvider.VwfsTransportingWheelsTransport,
  TransportationProvider.VwfsRhTransport,
  TransportationProvider.VwfsMosolfTransport,
];

export const PROVIDERS_SHOWN_AS_VIA_ALLMOBIL: TransportationProvider[] = [
  TransportationProvider.VwfsTransportingWheelsTransport,
  TransportationProvider.VwfsRhTransport,
  TransportationProvider.VwfsAllmobilTransport,
  TransportationProvider.VwfsMosolfTransport,
];

// IRIS-5622
// Battery Capacity is only relevant for specific fuel types, for others we do not want to show it, even if we have data
export const FUELS_WITH_BATTERY_CAPACITY = [
  NormalizedFuelDetail.DieselHybridPlugin,
  NormalizedFuelDetail.Elektro,
  NormalizedFuelDetail.PetrolHybridPlugin,
];
